(function () {
  const doc = document;
  const header = doc.querySelector("[data-site-header]");
  const menuBtn = doc.querySelector("[data-menu-toggle]");
  const drawer = doc.querySelector("[data-mobile-drawer]");
  const overlay = doc.querySelector("[data-drawer-overlay]");
  const closeTargets = doc.querySelectorAll("[data-drawer-close]");

  function setScrolled() {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 8);
  }

  function openMenu() {
    if (!drawer || !menuBtn) return;
    drawer.classList.add("is-open");
    drawer.removeAttribute("hidden");
    menuBtn.setAttribute("aria-expanded", "true");
    doc.body.classList.add("menu-open");
    const first = drawer.querySelector("a, button");
    if (first) first.focus();
  }

  function closeMenu() {
    if (!drawer || !menuBtn) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("hidden", "");
    menuBtn.setAttribute("aria-expanded", "false");
    doc.body.classList.remove("menu-open");
  }

  window.addEventListener("scroll", setScrolled, { passive: true });
  setScrolled();

  if (menuBtn) {
    menuBtn.addEventListener("click", function () {
      const open = menuBtn.getAttribute("aria-expanded") === "true";
      if (open) closeMenu();
      else openMenu();
    });
  }

  if (overlay) overlay.addEventListener("click", closeMenu);
  closeTargets.forEach(function (el) {
    el.addEventListener("click", closeMenu);
  });

  doc.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeMenu();
  });

  doc.querySelectorAll("[data-carousel]").forEach(function (root) {
    const slides = Array.from(root.querySelectorAll("[data-slide]"));
    if (!slides.length) return;
    const dots = Array.from(root.querySelectorAll("[data-dot]"));
    const prev = root.querySelector("[data-prev]");
    const next = root.querySelector("[data-next]");
    let index = 0;
    let timer;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        slide.classList.toggle("is-active", n === index);
        slide.setAttribute("aria-hidden", n === index ? "false" : "true");
      });
      dots.forEach(function (dot, n) {
        dot.classList.toggle("is-active", n === index);
        dot.setAttribute("aria-current", n === index ? "true" : "false");
      });
    }

    function start() {
      if (slides.length < 2) return;
      stop();
      timer = window.setInterval(function () {
        show(index + 1);
      }, 5000);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
    }

    if (prev) prev.addEventListener("click", function () { show(index - 1); start(); });
    if (next) next.addEventListener("click", function () { show(index + 1); start(); });
    dots.forEach(function (dot, n) {
      dot.addEventListener("click", function () { show(n); start(); });
    });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", start);
    show(0);
    start();
  });

  doc.querySelectorAll("[data-product-card]").forEach(function (card) {
    card.addEventListener("mousemove", function (event) {
      const rect = card.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      card.style.background = "radial-gradient(circle at " + x + "% " + y + "%, hsl(var(--card)) 0%, hsl(240 7% 9%) 100%)";
    });
    card.addEventListener("mouseleave", function () {
      card.style.background = "";
    });
  });

  const filterToggle = doc.querySelector("[data-filter-toggle]");
  const filterDrawer = doc.querySelector("[data-filter-drawer]");
  const filterOverlay = doc.querySelector("[data-filter-overlay]");
  const filterClose = doc.querySelector("[data-filter-close]");

  function openFilters() {
    if (!filterDrawer) return;
    filterDrawer.classList.add("is-open");
    if (filterOverlay) {
      filterOverlay.hidden = false;
      filterOverlay.classList.add("is-open");
    }
    if (filterToggle) filterToggle.setAttribute("aria-expanded", "true");
    doc.body.classList.add("filters-open");
  }

  function closeFilters() {
    if (!filterDrawer) return;
    filterDrawer.classList.remove("is-open");
    if (filterOverlay) {
      filterOverlay.hidden = true;
      filterOverlay.classList.remove("is-open");
    }
    if (filterToggle) filterToggle.setAttribute("aria-expanded", "false");
    doc.body.classList.remove("filters-open");
  }

  if (filterToggle) filterToggle.addEventListener("click", function () {
    const open = filterToggle.getAttribute("aria-expanded") === "true";
    if (open) closeFilters();
    else openFilters();
  });
  if (filterOverlay) filterOverlay.addEventListener("click", closeFilters);
  if (filterClose) filterClose.addEventListener("click", closeFilters);
  doc.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeFilters();
  });

  const facetForm = doc.getElementById("FacetFiltersForm");
  if (facetForm) {
    facetForm.addEventListener("change", function (event) {
      if (event.target && event.target.matches("input, select") && !event.target.hasAttribute("data-shop-search")) {
        facetForm.requestSubmit();
      }
    });
  }

  doc.querySelectorAll("[data-shop-search]").forEach(function (input) {
    input.addEventListener("keydown", function (event) {
      if (event.key !== "Enter") return;
      event.preventDefault();
      event.stopPropagation();
      const query = String(input.value || "").trim();
      if (!query) return;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      window.location.href = root + "search?q=" + encodeURIComponent(query) + "&type=product";
    });
  });

  const gallery = doc.querySelector("[data-gallery]");
  if (gallery) {
    const main = gallery.querySelector("[data-gallery-main]");
    const thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    const lightbox = gallery.querySelector("[data-lightbox]");
    const lightboxImg = gallery.querySelector("[data-lightbox-image]");
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (main) {
          main.src = thumb.getAttribute("data-src");
          main.alt = thumb.getAttribute("data-alt") || "";
        }
        thumbs.forEach(function (el) {
          el.classList.toggle("is-active", el === thumb);
          el.setAttribute("aria-pressed", el === thumb ? "true" : "false");
        });
      });
    });
    const openLightbox = gallery.querySelector("[data-lightbox-open]");
    if (openLightbox && lightbox && main) {
      openLightbox.addEventListener("click", function () {
        if (lightboxImg) {
          lightboxImg.src = main.currentSrc || main.src;
          lightboxImg.alt = main.alt || "";
        }
        if (typeof lightbox.showModal === "function") lightbox.showModal();
      });
    }
    gallery.querySelectorAll("[data-lightbox-close]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (lightbox && typeof lightbox.close === "function") lightbox.close();
      });
    });
    if (lightbox) {
      lightbox.addEventListener("click", function (event) {
        if (event.target === lightbox && typeof lightbox.close === "function") lightbox.close();
      });
    }
  }

  function showToast(message) {
    const toast = doc.querySelector("[data-cart-toast]");
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    toast.classList.add("is-visible");
    window.setTimeout(function () {
      toast.classList.remove("is-visible");
      toast.hidden = true;
    }, 2800);
  }

  function updateCartCount(count) {
    const link = doc.querySelector(".cart-btn");
    if (!link) return;
    let badge = link.querySelector(".cart-count");
    if (count > 0) {
      if (!badge) {
        badge = doc.createElement("span");
        badge.className = "cart-count";
        link.appendChild(badge);
      }
      badge.textContent = String(count);
      link.setAttribute("aria-label", "Cart, " + count + " items");
    } else if (badge) {
      badge.remove();
    }
  }

  doc.querySelectorAll("[data-product-form]").forEach(function (form) {
    const minus = form.querySelector("[data-qty-minus]");
    const plus = form.querySelector("[data-qty-plus]");
    const qty = form.querySelector('input[name="quantity"]');
    if (minus && qty) {
      minus.addEventListener("click", function () {
        qty.value = String(Math.max(1, parseInt(qty.value, 10) - 1 || 1));
      });
    }
    if (plus && qty) {
      plus.addEventListener("click", function () {
        const max = parseInt(qty.getAttribute("max") || "999", 10);
        qty.value = String(Math.min(max, (parseInt(qty.value, 10) || 1) + 1));
      });
    }
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      const button = form.querySelector("[data-add-to-cart]");
      const label = form.querySelector("[data-add-label]");
      if (button) button.disabled = true;
      if (label) label.textContent = "Adding...";
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      fetch(root + "cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
        .then(function (res) {
          if (!res.ok) throw new Error("Add to cart failed");
          return fetch(root + "cart.js");
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          showToast("Added to cart");
        })
        .catch(function () {
          showToast("Could not add to cart");
        })
        .finally(function () {
          if (button) button.disabled = false;
          if (label) label.textContent = "Add to Cart";
        });
    });
  });

  const related = doc.querySelector("[data-related-products]");
  if (related && related.getAttribute("data-url") && related.getAttribute("data-product-id")) {
    const recUrl = related.getAttribute("data-url") + "?section_id=" + related.getAttribute("data-section-id") + "&product_id=" + related.getAttribute("data-product-id");
    fetch(recUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        const parser = new DOMParser();
        const incoming = parser.parseFromString(html, "text/html").querySelector("[data-related-products]");
        if (incoming) related.replaceWith(incoming);
      })
      .catch(function () {});
  }

  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function changeCartLine(key, quantity, sectionId) {
    const rootEl = doc.querySelector("[data-cart-root]");
    if (rootEl) rootEl.classList.add("is-updating");
    return fetch(shopifyRoot() + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) {
        return res.json().then(function (payload) {
          if (!res.ok) {
            const message = payload.description || payload.message || "Could not update cart";
            throw new Error(message);
          }
          return payload;
        });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (!sectionId) return cart;
        return fetch(window.location.pathname + "?section_id=" + encodeURIComponent(sectionId))
          .then(function (res) { return res.text(); })
          .then(function (html) {
            const incoming = new DOMParser().parseFromString(html, "text/html").querySelector("[data-cart-root]");
            const current = doc.querySelector("[data-cart-root]");
            if (incoming && current) current.replaceWith(incoming);
            return cart;
          });
      })
      .catch(function (error) {
        showToast(error.message || "Could not update cart");
        const stuck = doc.querySelector("[data-cart-root]");
        if (stuck) stuck.classList.remove("is-updating");
      });
  }

  doc.addEventListener("click", function (event) {
    const rootEl = event.target.closest("[data-cart-root]");
    if (!rootEl) return;
    const sectionId = rootEl.getAttribute("data-section-id");
    const minus = event.target.closest("[data-cart-minus]");
    const plus = event.target.closest("[data-cart-plus]");
    const remove = event.target.closest("[data-cart-remove]");
    if (minus || plus) {
      event.preventDefault();
      const line = event.target.closest("[data-cart-line]");
      const input = line && line.querySelector("[data-cart-qty]");
      if (!input) return;
      const current = parseInt(input.value, 10) || 1;
      const max = parseInt(input.getAttribute("max") || "999", 10);
      const next = minus ? Math.max(0, current - 1) : Math.min(max, current + 1);
      changeCartLine(input.getAttribute("data-line-key"), next, sectionId);
    } else if (remove) {
      event.preventDefault();
      changeCartLine(remove.getAttribute("data-line-key"), 0, sectionId);
    }
  });

  doc.addEventListener("change", function (event) {
    const input = event.target.closest("[data-cart-qty]");
    if (!input) return;
    const rootEl = input.closest("[data-cart-root]");
    if (!rootEl) return;
    const quantity = Math.max(0, parseInt(input.value, 10) || 0);
    changeCartLine(input.getAttribute("data-line-key"), quantity, rootEl.getAttribute("data-section-id"));
  });
})();
